export default "__VITE_ASSET__hui16I8F__"